import { Dialog, DialogPanel } from '@headlessui/react'
import { Button, XIcon } from '@tovala/component-library'
import { clsx } from 'clsx'
import { motion } from 'motion/react'
import { ReactNode, useEffect } from 'react'

import { useOverlays } from 'contexts/overlays'

export type RatingDialogSize = 'multiMeal' | 'singleMeal'
type CloseButtonStyle = 'dark' | 'orange'

const CLOSE_ICON_COLOR_CLASS_MAP: { [key in CloseButtonStyle]: string } = {
  dark: 'text-inherit',
  orange: 'text-orange-2',
}

const RatingDialog = ({
  children,
  onClose,
  size,
}: {
  children: ReactNode
  onClose: () => void
  size: RatingDialogSize
}) => {
  const { trackRatingDialogOpen } = useOverlays()

  useEffect(() => trackRatingDialogOpen(), [trackRatingDialogOpen])

  return (
    <Dialog onClose={onClose} open={true}>
      <div
        className="fixed inset-0 z-30 h-full w-full bg-black opacity-40"
        onClick={onClose}
      />
      <div className="fixed inset-0 z-30 flex h-full max-h-screen w-full items-center justify-center overflow-auto md:items-end">
        <DialogPanel className="overflow-y-auto px-2 md:w-full md:pb-2">
          <motion.div
            animate={{ opacity: 1 }}
            className={clsx(
              'relative max-h-[calc(100dvh-1rem)] bg-white md:w-full md:max-w-[462px]',
              size === 'multiMeal'
                ? 'w-[599px] overflow-hidden rounded-2xl md:rounded-[22px]'
                : 'w-[462px] overflow-y-auto rounded-lg',
            )}
            initial={{ opacity: 0 }}
          >
            {children}
          </motion.div>
        </DialogPanel>
      </div>
    </Dialog>
  )
}

export default RatingDialog

export const RatingDialogCloseButton = ({
  buttonStyle = 'dark',
  onClose,
}: {
  buttonStyle?: CloseButtonStyle
  onClose(): void
}) => {
  return (
    <Button aria-label="Close" buttonStyle="link" onClick={onClose} size="auto">
      <div className={clsx('h-6 w-6', CLOSE_ICON_COLOR_CLASS_MAP[buttonStyle])}>
        <XIcon />
      </div>
    </Button>
  )
}
